import styled from "styled-components";

export const PageSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const FiltersCard = styled.div`
	display: flex;
	flex-direction: column;
	padding: 14px 16px;
	border-radius: 8px;
	border: 1px solid rgba(120, 139, 160, 0.14);
	background-color: var(--light-1);
`;

export const FiltersGridWrap = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 12px;
	flex-wrap: wrap;

	& > div:first-child {
		flex: 1 1 760px;
		min-width: min(100%, 640px);
	}
`;

export const FiltersGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 8px 12px;

	& > div {
		flex: 1 1 170px;
		min-width: 150px;
	}

	@media (max-width: 720px) {
		& > div {
			flex-basis: 100%;
		}
	}
`;

export const FilterActionsRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
	flex-wrap: wrap;
	flex: 0 0 auto;

	@media (max-width: 720px) {
		width: 100%;
		justify-content: flex-start;
		& > button {
			flex: 1 1 140px;
		}
	}
`;

export const TableSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;
`;

export const TableCard = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 16px 14px;
	border-radius: 8px;
	border: 1px solid rgba(120, 139, 160, 0.14);
	background-color: var(--light-1);
	overflow: hidden;

	& > div:first-child {
		margin-top: 0;
	}

	& table > thead {
		background-color: var(--light-1);
	}

	& table > thead th {
		border-bottom: 1px solid rgba(120, 139, 160, 0.16);
	}

	& table > thead th:last-child {
		width: 0;
		padding: 0;
		border-bottom: 0;
	}

	& table > thead th:last-child > div {
		display: none;
	}

	& table thead th > div {
		margin-bottom: 8px;
		min-height: 34px;
		padding: 0 6px 2px;
	}

	& table thead th span {
		font-size: 11px;
		line-height: 1.2;
	}

	& table tbody td {
		padding: 8px 6px;
		vertical-align: middle;
	}

	& table tbody tr {
		border-top: 1px solid rgba(120, 139, 160, 0.12);
		line-height: 1.25;
	}

	& table tbody tr:first-child {
		border-top: 0;
	}
`;
export const CampusCell = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-width: 0;
	min-width: 176px;
	max-width: 176px;
	padding: 2px 0;
`;

export const NameCell = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2px;
	min-width: 0;
	min-width: 220px;
	max-width: 260px;
	padding: 2px 0;

	& strong {
		font-size: 12px;
		font-weight: 600;
		line-height: 1.3;
		color: var(--black);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	& span {
		font-size: 11px;
		line-height: 1.25;
		color: var(--light-gray-5);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const TypeCell = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-width: 0;
	min-width: 132px;
	max-width: 148px;
	padding: 2px 0;

	& strong {
		font-size: 12px;
		font-weight: 600;
		line-height: 1.3;
		color: var(--black);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const StatusBadge = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	border-radius: 999px;
	font-size: 10px;
	font-weight: 600;
	line-height: 1.2;
	background-color: ${({ active }) =>
		active ? "var(--light-blue-2)" : "var(--light-gray-1)"};
	color: ${({ active }) =>
		active ? "var(--light-blue-5)" : "var(--light-gray-5)"};
`;

export const ActionCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 52px;
	padding: 2px 0;
`;

export const CampusTagList = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 4px;
	max-width: 100%;
	overflow: hidden;
`;

export const CampusTag = styled.span`
	display: inline-flex;
	align-items: center;
	max-width: 104px;
	padding: 3px 7px;
	border-radius: 6px;
	background-color: var(--light-blue-2);
	color: var(--light-blue-5);
	font-size: 10px;
	font-weight: 500;
	line-height: 1.2;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const DialogFormContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	width: 100%;
	max-height: min(74vh, 860px);
	overflow-y: auto;
	padding: 0 14px 8px 2px;

	@media (max-width: 900px) {
		max-height: 68vh;
		padding-right: 8px;
	}
`;

export const DialogLead = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 4px 2px 0;

	& h4 {
		margin: 0;
		font-size: 17px;
		font-weight: 700;
		color: var(--black);
	}

	& p {
		margin: 0;
		font-size: 12px;
		line-height: 1.5;
		color: var(--light-gray-5);
	}
`;

export const HelperCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	border-radius: 8px;
	background-color: var(--light-blue-2);
	& h5 {
		margin: 0;
		font-size: 14px;
	}
	& p {
		margin: 0;
		font-size: 13px;
		color: var(--light-gray-5);
		line-height: 1.55;
	}
`;

export const FormSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 18px 2px 0;
	border-top: 1px solid rgba(120, 139, 160, 0.18);

	&:first-of-type {
		padding-top: 6px;
		border-top: 0;
	}
`;

export const SectionHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;

	& h4 {
		margin: 0;
		font-size: 13px;
		font-weight: 700;
		letter-spacing: 0.01em;
		color: var(--black);
	}

	& p {
		margin: 0;
		font-size: 11px;
		line-height: 1.45;
		color: var(--light-gray-5);
	}
`;

export const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(220px, 1fr));
	gap: 12px 18px;
	align-items: start;

	@media (max-width: 780px) {
		grid-template-columns: 1fr;
	}
`;

export const CompactGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px 18px;
	align-items: start;

	@media (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const DualSectionGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
	gap: 18px 22px;
	align-items: start;

	@media (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const Subsection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-width: 0;
`;

export const StackFields = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-width: 0;
`;

export const SubsectionHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;

	& h5 {
		margin: 0;
		font-size: 13px;
		font-weight: 700;
		color: var(--black);
	}

	& p {
		margin: 0;
		font-size: 11px;
		line-height: 1.45;
		color: var(--light-gray-5);
	}
`;

export const CampusSelectionCard = styled.div`
	padding: 0;
	border: 0;
	background-color: transparent;

	& > div {
		width: 100%;
		gap: 8px;
	}

	& .flex-start {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
		gap: 8px 10px;
		width: 100%;
	}

	& .flex-start > div {
		padding: 10px 12px;
		border-radius: 10px;
		border: 1px solid rgba(120, 139, 160, 0.14);
		background-color: rgba(255, 255, 255, 0.98);
		gap: 8px;
		min-height: 42px;
	}

	& .flex-start > div label {
		font-size: 13px;
		color: var(--dark-4);
		line-height: 1.35;
	}
`;

export const FileInfoCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
	padding: 12px 14px;
	border-radius: 12px;
	background-color: rgba(245, 247, 252, 0.84);
	border: 1px solid rgba(120, 139, 160, 0.14);

	& strong,
	& button,
	& span {
		word-break: break-word;
	}

	& span {
		font-size: 13px;
		line-height: 1.5;
		color: var(--light-gray-5);
	}

	@media (max-width: 720px) {
		align-items: flex-start;
	}
`;

export const UploadFieldWrap = styled.div`
	width: 100%;

	& form {
		width: 100%;
		min-width: 0;
	}

	& section {
		width: 100%;
	}
`;

export const WarningBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 12px 14px;
	border-radius: 12px;
	border: 1px solid rgba(242, 208, 138, 0.72);
	background-color: rgba(255, 249, 235, 0.78);

	& p {
		margin: 0;
		font-size: 12px;
		line-height: 1.5;
		color: #7a5a11;
	}
`;

export const ErrorAlertBlock = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 12px 14px;
	border-radius: 12px;
	border: 1px solid rgba(239, 179, 179, 0.86);
	background-color: rgba(255, 241, 241, 0.82);

	& p {
		margin: 0;
		font-size: 12px;
		line-height: 1.5;
		color: #a12626;
		font-weight: 500;
	}
`;

export const FooterActions = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	justify-content: stretch;
	align-items: stretch;
	gap: 10px;
	width: 100%;
	max-width: 100%;
	min-width: 0;

	& > div {
		width: 100%;
		min-width: 0;
	}

	& > div > button {
		width: 100%;
		min-width: 0;
	}

	& > div > button > span {
		white-space: normal;
		text-align: center;
		line-height: 1.2;
	}

	@media (max-width: 560px) {
		gap: 8px;

		& > div > button {
			padding-left: 10px;
			padding-right: 10px;
		}
	}
`;

export const PreviewContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	min-width: min(78vw, 860px);
	max-width: 860px;
`;

export const PreviewHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	& h4 {
		margin: 0;
		font-size: 16px;
		color: var(--black);
		word-break: break-word;
	}

	& p {
		margin: 0;
		font-size: 13px;
		line-height: 1.55;
		color: var(--light-gray-5);
		word-break: break-word;
	}
`;

export const PreviewFrame = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 300px;
	max-height: min(70vh, 720px);
	padding: 18px;
	border-radius: 14px;
	border: 1px solid var(--light-gray-2);
	background:
		linear-gradient(135deg, rgba(241, 244, 255, 0.95), rgba(250, 251, 255, 0.98));
	overflow: auto;

	& img {
		display: block;
		max-width: 100%;
		max-height: min(62vh, 640px);
		object-fit: contain;
		border-radius: 8px;
		box-shadow: 0 20px 36px -30px rgba(22, 29, 31, 0.55);
		background: var(--white);
	}
`;

export const ActionIconButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: 0;
	border-radius: 6px;
	background-color: transparent;
	color: ${({ tone = "default" }) => {
		switch (tone) {
		case "success":
			return "var(--green-3)";
		case "warning":
			return "var(--purple-6)";
		default:
			return "var(--purple-2)";
		}
	}};
	cursor: pointer;
	transition: background-color 0.25s ease, color 0.25s ease, transform 0.2s ease;

	&:hover {
		background-color: var(--light-blue-2);
	}

	&:active {
		transform: scale(0.96);
	}

	& svg {
		width: 16px;
		height: 16px;
	}

	& svg path,
	& svg circle,
	& svg rect {
		fill: currentColor;
	}
`;

export const ValidityCell = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2px;
	min-width: 0;
	min-width: 148px;
	max-width: 170px;
	padding: 2px 0;

	& strong {
		font-size: 11px;
		line-height: 1.25;
		color: var(--black);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	& span {
		font-size: 10px;
		line-height: 1.25;
		color: var(--light-gray-5);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
